import { connect } from "react-redux"

import { addProduct } from "../../../redux/cart/actions"
import ProductCardView from "./add-to-cart-button-view"

export default connect(null, { addProduct })(ProductCardView)
